import React, { useState } from 'react';

export default function StepCard({ step, isSelected, onClick, onHover }) {
  const [isHovered, setIsHovered] = useState(false);
  const isFixed = step.isStart || step.isEnd;

  const handleMouseEnter = () => {
    setIsHovered(true);
    if (onHover) onHover(step);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    if (onHover) onHover(null);
  };

  const getBorder = () => {
    if (isSelected) return '2px solid #3b82f6';
    return '1px solid #e5e7eb';
  };

  // Determine label and value for bottom bar
  let label = null;
  let value = null;

  if (step.nodeId === 'start') {
    label = 'File';
    value = 'CLAUDE.md';
  } else if (step.nodeId === 'prompt') {
    label = 'Input Location';
    value = step.fileName || 'Terminal';
  } else if (step.nodeId === 'response') {
    label = 'Model';
    value = step.fileName || 'Claude';
  } else {
    label = 'File';
    value = step.fileName || (step.filepath && step.filepath.split('/').pop()) || null;
  }

  const displayName = label && value ? { label, value } : null;

  // Determine the type/category of the step - only show for skills
  const getStepType = () => {
    if (step.filepath && step.filepath.toUpperCase().includes('SKILL')) return 'skill';
    if (step.fileName && step.fileName.toUpperCase().includes('SKILL')) return 'skill';
    return null;
  };

  const stepType = getStepType();

  return (
    <div
      onClick={onClick}
      style={{
        background: step.nodeId === 'prompt' ? '#f0fdf4' : step.nodeId === 'response' ? '#fdf2f8' : isFixed ? '#f3f4f6' : '#fff',
        border: getBorder(),
        borderRadius: '12px',
        overflow: 'hidden',
        transition: 'all 0.2s ease',
        boxShadow: isSelected ? '0 4px 12px rgba(59, 130, 246, 0.15)' : isHovered ? '0 2px 8px rgba(0,0,0,0.08)' : '0 1px 3px rgba(0,0,0,0.05)',
        cursor: 'pointer',
        position: 'relative'
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Type tag in top right corner */}
      {stepType && (
        <div style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          color: '#8b5cf6',
          fontSize: '10px',
          fontWeight: 600,
          textTransform: 'lowercase',
          letterSpacing: '0.03em',
          zIndex: 1
        }}>
          {stepType}
        </div>
      )}

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '14px 16px',
          paddingBottom: displayName ? '10px' : '14px'
        }}
      >
        {/* Icon */}
        <div style={{
          width: '40px',
          height: '40px',
          borderRadius: '10px',
          background: step.iconBg || '#f3f4f6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '20px',
          marginRight: '12px',
          flexShrink: 0
        }}>
          {step.icon}
        </div>

        {/* Name & Subtitle */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{
            fontSize: '14px',
            fontWeight: 600,
            color: '#111827',
            marginBottom: '2px'
          }}>
            {step.name}
          </div>
          <div style={{
            fontSize: '12px',
            color: '#6b7280',
            lineHeight: '1.4'
          }}>
            {step.subtitle}
          </div>
        </div>
      </div>

      {/* File name - material style bottom bar */}
      {displayName && (
        <div style={{
          padding: '6px 16px 10px',
          borderTop: '1px solid #f3f4f6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <span style={{
            fontSize: '11px',
            color: isSelected ? '#3b82f6' : '#6b7280',
            fontWeight: 600,
            letterSpacing: '0.01em'
          }}>
            {displayName.label}
          </span>
          <span style={{
            fontSize: '11px',
            color: isSelected ? '#3b82f6' : '#9ca3af',
            fontWeight: 500,
            letterSpacing: '0.01em'
          }}>
            {displayName.value}
          </span>
        </div>
      )}
    </div>
  );
}
